export default "__VITE_ASSET__BegOxbm1__"